import React from "react";
import {createContext} from "@core-ui/utility";
import {AppState} from "./types";

export type TypedUseAppState<TState> = () => TState & AppState;

const missingContextMessage =
  "useAppState called without being explicitly wrapped by AppStateProvider";

const [extendableUseAppState, AppContext]: [
  <ExtendedAppState = Record<string, unknown>>() => AppState & ExtendedAppState,
  React.Context<AppState | undefined>
] = createContext<AppState>(missingContextMessage);

export const AppStateProvider = AppContext.Provider;

export const useAppState = (): AppState => extendableUseAppState<unknown>();

export {extendableUseAppState, AppContext};
